<template>
  <div>
    <div v-if="mobileOpen" class="sidebar-overlay fixed w-full h-full bg-black-alpha-40 z-40 md:hidden"
      @click="$emit('close-mobile')"></div>

    <aside class="surface-card flex flex-column ease-in-out" :class="[
      'md:relative md:translate-x-0',
      isDesktop ? (collapsed ? 'md:w-5rem ' : 'md:w-16rem') : '',
      !isDesktop && mobileOpen ? 'mobile-open' : '',
      !isDesktop && !mobileOpen ? 'mobile-closed' : ''
    ]">
      <div class="p-4 border-bottom-1 surface-border">
        <div class="flex align-items-center justify-content-center">
          <div class="flex align-items-center gap-2">
            <div class="nav-bar flex align-items-center w-full sticky top-0 z-5" >
              <img :src="topNavlogo" alt="Illustration" class="topnavbar max-w-full max-h-full object-contain" />
            </div>
          </div>
          <Button v-if="mobileOpen" class="p-button-text p-button-sm md:hidden" @click="$emit('close-mobile')">
            <i class="pi pi-times" />
          </Button>
        </div>
      </div>
      <div class="flex-1 overflow-y-auto  py-2" :class="userTypeClass">
        <ul class="list-none p-0 m-0  ">
          <li v-for="item in menuItems" :key="item.label"
            class="flex align-items-center mb-2  cursor-pointer hover:surface-hover transition-colors rounded-md mx-2"
            :class="{ 'active-item': isActive(item.to) }">
            <router-link :to="item.to"
              class="flex px-3 py-3 items-center justify-start w-full h-full text-current menu-link no-underline"
              @click="$emit('close-mobile')">
              <i :class="item.icon" class="ml-2 mr-3 text-lg"></i>
              <span class="overflow-hidden Lable whitespace-nowrap" :class="[
                collapsed ? 'w-0 opacity-0 md:opacity-100 hidden' : 'w-auto opacity-100',
                isActive(item) ? 'Lable' : ''
              ]">
                {{ item.label }}
              </span>
              <span v-if="item.count > 0" 
                class="ml-auto bg-red-500 text-white text-xs font-bold px-2 py-1 rounded-full flex align-items-center justify-content-center"
                style="min-width: 20px; height: 20px; border-radius: 5px;">{{ item.count }}
              </span>
              <span class="Caption w-4 pl-2" v-if="item.test"> Temporary test page </span>
            </router-link>
            <span class="Caption" v-if="item.label === 'Tutor Profiles'"> Note: This is just for testing perposes.</span>
          </li>
        
        </ul>
      </div>
      
      <div class="flex justify-content-start align-items-start md:block hidden">
       
        <Button class="p-button-text p-button-sm flex align-items-center justify-content-start"
          @click="$emit('toggle')">
          <i :class="[isDesktop ? (collapsed ? 'pi pi-angle-right' : 'pi pi-angle-left') : '']" class="" />
        </Button>
      </div>
    </aside>
  </div>
</template>

<script setup>
import Button from 'primevue/button';
import { defineProps, computed, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import topNavlogo from "@/assets/topNavLogo.png";
import * as api from '@/api/tutor';

const props = defineProps({
  collapsed: Boolean,
  mobileOpen: Boolean,
  isDesktop: Boolean,
  role :String
});

const classRequests = ref(0);
const route = useRoute();
const menuItems = computed(() => {
  if (props.role === 'student') {
    return [
      { label: "Class Schedules", icon: "pi pi-calendar", to: "/student_dashboard" },
      { label: "Class Confirmations", icon: "pi pi-check-circle", to: "/student_dashboard/confirmations" },
      { label: "Enrolled Tutors", icon: "pi pi-users", to: "/student_dashboard/enrolledTutors" },
      { label: "Notes", icon: "pi pi-pencil", to: "/student_dashboard/studentNotes" },
      { label: "Results", icon: "pi pi-chart-bar", to: "/student_dashboard/studentResults" },
      { label: "Home works", icon: "pi pi-book", to: "/student_dashboard/homework" },
      { label: "Revision", icon: "pi pi-refresh", to: "/student_dashboard/revision" },
      { label: "Past papers", icon: "pi pi-file", to: "/student_dashboard/pastPapers" },
      // { label: "Tutor Profiles", icon: "pi pi-users", to: "/student_dashboard/test-tutor-profiles" },
    ];
  } else if (props.role === 'tutor') {
    return [
      { label: "Class Schedules", icon: "pi pi-bell", to: "/tutor_dashboard" },
      { label: "Class Requests", icon: "pi pi-verified", to: "/tutor_dashboard/classRequests", count: classRequests.value },
      { label: "Notices", icon: "pi pi-file-check", to: "/tutor_dashboard/tutorNotice" },
      { label: "Enrolled Students", icon: "pi pi-user-plus ", to: "/tutor_dashboard/enrolledStudents" },
      { label: "To-do list", icon: "pi pi-list-check", to: "/tutor_dashboard/to-do-list" },
      { label: "Programs", icon: "pi pi-graduation-cap", to: "/tutor_dashboard/programs" },
      { label: "Past papers", icon: "pi pi-file", to: "/tutor_dashboard/pastPapers" },
      // { label: "Payments", icon: "pi pi-wallet", to: "/tutor_dashboard/payments", test: true },
    ];
  } else if (props.role === 'institute') {
    return [
      // { label: "Class Schedules", icon: "pi pi-calendar-clock", to: "/institution_dashboard" },
      { label: "Our Tutors", icon: "pi pi-address-book", to: "/ourTutors"},
      { label: "Our Students", icon: "pi pi-address-book", to: "/ourStudents"},
    ];
  } else {
    return [];
  }
});

const fetchClassRequests = async () => {
    try {
        const response = await api.fetchRequests();
        classRequests.value = response.data.data.length;
    } catch (error) {
        console.error("Error fetching class requests:", error);
    }
};
const isActive = (path) => {
  return route.path === path;
};
const userTypeClass = computed(() => {
  switch (props.role) {
    case "student":
      return "menu-student";
    case "tutor":
      return "menu-tutor";
    case "institute":
      return "menu-institution";
    default:
      return "menu-default";
  }
});

watch(() => props.role, (newRole) => {
  if (newRole === 'tutor') {
    fetchClassRequests();
  }
}, { immediate: true });
</script>

<style scoped>
.topnavbar {
  width: 160px;
  height: auto;
}

.surface-card {
  background-color: var(--gray-400) !important;
  height: 100dvh;
}

.sidebar-overlay {
  backdrop-filter: blur(0.5px) !important;
  z-index: 50 !important;
}

li {
  border-radius: 0.375rem;
  margin: 0 0.5rem;
}

.mobile-open, .mobile-closed {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  z-index: 50 !important;
  width: 16rem !important;
  height: 100% !important;
  transition: transform 0.8s ease-in-out !important;
  will-change: transform !important
}
.mobile-open {
  transform: translateX(0) !important;
}

.mobile-closed {
  transform: translateX(-100%) !important;
}

.menu-link {
  text-decoration: none;
  color: inherit;
  display: flex;
  align-items: center;
}

.menu-default li:hover { background-color: var(--teal-400); }
.menu-default .active-item { background-color: var(--teal-400); }
.menu-student li:hover { background-color: var(--orange-50) !important; }
.menu-student .active-item { background-color: var(--orange-50); }
.menu-tutor li:hover { background-color: var(--teal-400) !important; }
.menu-tutor .active-item { background-color: var(--teal-400); }
.menu-institution li:hover { background-color: var(--yellow-50) !important; }
.menu-institution .active-item { background-color: var(--yellow-50); }

.p-button-text {
  color: var(--gray-600);
}
@media (max-width: 767px) {
  aside {
    z-index: 50 !important;
  }

  .title {
    font-size: 18px;

  }
}
</style>
